import Paginate from 'vuejs-paginate'
import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import ProjectItem from './../ProjectItem/index.vue'
import { Api, Toast } from './../../../services'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Paginate,
    ProjectItem,
  },
  mounted() {},
  data() {
    return {
      projects: null,
      pageNumber: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: '',
      search: {
        text: '',
        type: 'all',
        numberPage: 1,
        countPages: 1,
        limit: 9,
        my: true,
      },
      affiliate: false,
      amount: null,
      prjId: "",
      prjOwner: "",
      walletAddress: "",
      user: "",
      paymentWallet: "",
      walletCbx: "BTC",
      wBTC: "3L2QFskrhzHshkbpuhnHVpCGAz7JoQraHk",
      wETH: "0x26139abf60a81c1a962e5563a510324c4756ed37",
      wUSDT: "0xdac17f958d2ee523a2206206994597c13d831ec7",
      toWallet: "",
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.type = this.$route.query.type || 'all'
      this.search.numberPage = +this.$route.query.page || 1
      this.search.my = this.$route.query.my || false     
       
      this.refreshDisplayProjects()
    },
  },
  methods: {
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },

   
    async refreshDisplayProjects() {
      try {
        this.$refs.progress.show()

        var response = await Api.getProjects(this.search)
        
        this.projects = response.data.results

        this.search.countPages = response.data.pagination.countPages
        console.log("this.projects **********")
        console.log(this.projects)

      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        this.$refs.progress.hide()
      }
    },
    ownerData(owner){
      this.prjOwner = owner
    },
    async saveGREEN (){
      console.log("saveGREEN ****************************  *****")
      console.log(this.amount)
       try {
        // if (this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressETH == '' && this.profileData.user.walletAddressEOS == '') return;
        this.$refs.progress.show()       

        var response = await Api.myProfileSmallInfo()
        this.user = response.data.user

        var formData = new FormData()
        // formData.append('coin', this.walletName)
        this.prjId = $('#prjId').val(); 
        this.prjOwner = $('#prjOwner').val();
        var userEth = this.user.walletAddressGREEN
        
        var userOwnerEmail = this.prjOwner ? (JSON.parse(this.prjOwner)).email : this.$localStorage.get("userEmail")
        formData.append('amount', this.amount)
        formData.append('userOwnerEmail', userOwnerEmail)
        formData.append('projectId', this.prjId)
        formData.append('walletAddress', this.paymentWallet)
        formData.append('toWallet', this.toWallet)
        formData.append('paymentCoin', this.walletCbx)
        
        var response = await Api.saveGREEN(formData) 

        // console.log("res --------------------")  
        console.log(this.prjId , this.prjOwner)  

        $('.modal').modal('hide')
            $('.modal-backdrop.in').remove()    

        // if (this.profileData.user.fullName === '' || this.profileData.user.country === '' || this.profileData.user.address === '' || this.profileData.user.idPassportForKYC == undefined || this.profileData.user.idPassportForKYC.length <= 0) {

        //   var c = '', addr = '', p = '', b = ''
        //   c = this.profileData.user.country ? this.profileData.user.country : ''
        //   addr = this.profileData.user.address ? this.profileData.user.address : ''
        //   p = this.profileData.user.idPassportForKYC ? this.profileData.user.idPassportForKYC[0] : ''
        //   b = this.profileData.user.utilityBill ? this.profileData.user.utilityBill : ''

        //   this.$localStorage.set('address', addr)
        //   this.$localStorage.set('country', c)
        //   this.$localStorage.set('idPassportForKYC', p)
        //   this.$localStorage.set('utilityBill', b)

        //   this.$router.push('/kyc')

        // } else {
   
        //    Toast.success({
        //     toast: this.$toast,
        //     title: 'Success!',
        //     message: 'GREEN Successfully Saved',
        //   })
        // }   

      } catch (error) {
          console.log("error>>>>>>>>>>>>>>>>>>>>>>")
          console.log(error)
          this.validationMessage = 'Something went wrong.'

          Toast.error({
            toast: this.$toast,
            title: 'Error saveGREEN',
            message: 'Something went wrong.',
          })
      } finally {
          this.$refs.progress.hide()
      }    
  
    },
  },
  async created() {
    this.$route.query.my = true
    this.search.text = this.$route.query.text || ''
    this.search.type = this.$route.query.type || 'all'
    this.search.numberPage = +this.$route.query.page || 1
    this.search.limit = 20
    this.search.my = this.$route.query.my || false
    this.toWallet = this.wBTC

    this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/Projects/Projects.component.js